import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getArtifactTopicTags } from '../../services/artifactService'
import useNotifications from '../useNotifications'

/**
 * A hook to use a Patron info object. Accepts a patronId and boolean which tells us if
 * we should attempt to retrieve the patron info or not parameter.
 * @param {string} patronId uploader id retrieved from artifact as artifact.uploaderId
 * @returns {Object} object with loading boolean, error status/data, and patron object
 */
const useArtifactTopicTags = (artifactId) => {
  const { t } = useTranslation()
  const [topicTags, setTopicTags] = useState(null)
  const [shouldRefetch, setShouldRefetch] = useState(true)
  const { error } = useNotifications()

  useEffect(() => {
    getArtifactTopicTags(artifactId)
      .then((response) => {
        setTopicTags(response.data)
      })
      .catch((err) => {
        error(t('hooks.errors.retrievingArtifactTopicTags', `Error retrieving artifact topic tags`), err)
      })
  }, [artifactId, error, shouldRefetch, t])

  const refetch = () => {
    setShouldRefetch(!shouldRefetch)
  }

  return {
    topicTags,
    refetch,
  }
}

export default useArtifactTopicTags
